export const GET_ERRORS = 'GET_ERRORS';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SET_FID = 'SET_FID';


//字幕編輯區
// export const SET_PLAYER_EDITING_DATA = 'SET_PLAYER_EDITING_DATA';
export const SET_TABLE_SELECT_CELL = 'SET_TABLE_SELECT_CELL';
export const SET_XML_STRING_ARRAY = 'SET_XML_STRING_ARRAY';
export const SET_FIND_ALL_INPUT = 'SET_FIND_ALL_INPUT';
export const SET_FIND_ALL_LIST = 'SET_FIND_ALL_LIST';
export const SET_FIND_ALL_TARGETSTRING = 'SET_FIND_ALL_TARGETSTRING';
export const SET_IS_EDITMODE = 'SET_IS_EDITMODE';
export const SET_FIND_ALL_TARGET_DATA = 'SET_FIND_ALL_TARGET_DATA';
export const SET_FIND_ALL_SELECT_ROW_COL = 'SET_FIND_ALL_SELECT_ROW_COL';
export const SET_FIND_AND_REPLACE_SELECT_ROW_COL = 'SET_FIND_AND_REPLACE_SELECT_ROW_COL';
export const SET_FIND_ALL_SHOW_REPLACE = 'SET_FIND_ALL_SHOW_REPLACE';
export const SET_FIND_AND_REPLACE_SENTENCE = 'SET_FIND_AND_REPLACE_SENTENCE';
export const SET_FIND_AND_REPLACE_DATA = 'SET_FIND_AND_REPLACE_DATA';
export const SET_CELL = 'SET_CELL';
export const SET_COLUMNS = 'SET_COLUMNS';
export const SET_VIDEO_FPS = 'SET_VIDEO_FPS';
export const SET_readOnly = 'SET_readOnly';


//編輯Table區
export const INIT_DATA = 'INIT_DATA';
export const UPDATE_DATA = 'UPDATE_DATA';
export const UPDATE_READ_ONLY = 'UPDATE_READ_ONLY';
export const SET_EDITTABLE_HEIGHT = 'SET_EDITTABLE_HEIGHT';
export const SET_COLHEADERS = 'SET_COLHEADERS';
export const SET_HIDDEN_COLUMNS = 'SET_HIDDEN_COLUMNS';
export const UPDATE_COLUMNS_WIDTH = 'UPDATE_COLUMNS_WIDTH';


//Project
export const SET_STATUS_VALUE = 'SET_STATUS_VALUE';
export const SET_PROJECT_DETIAL_DATA = 'SET_PROJECT_DETIAL_DATA';
export const SET_VERSIONS = 'SET_VERSIONS';
export const SET_IS_EDIT = 'SET_IS_EDIT';
export const SET_SUBTYPE = 'SET_SUBTYPE';



//profile
export const GET_PROFILE = 'GET_PROFILE';
export const PROFILE_LOADING = 'PROFILE_LOADING';
export const CLEAR_CURRENT_PROFILE = 'CLEAR_CURRENT_PROFILE'; //logout

//platform
export const GET_PLATFORM_SUMMARY = 'GET_PLATFORM_SUMMARY';
export const PLATFORM_LOADING = 'PLATFORM_LOADING';
export const RENT_CASINO = 'RENT_CASINO';
export const CASINO_LIST_OWNER = 'CASINO_LIST_OWNER';
export const GET_DAILY_INCOME_LIST = 'GET_DAILY_INCOME_LIST';
export const GET_TOKEN_HOLDER_HISTORY = 'GET_TOKEN_HOLDER_HISTORY';
export const PROFIT_DIVIDEND = 'PROFIT_DIVIDEND';
export const GET_PROFIT_DIVIDEND_LIST = 'GET_PROFIT_DIVIDEND_LIST';
export const GET_GAME_SHARE_RECORD = 'GET_GAME_SHARE_RECORD';
export const GET_GAME_EXCHANGE_DAILY = 'GET_GAME_EXCHANGE_DAILY';
export const GET_GAME_PERSONAL_SHARE = 'GET_GAME_PERSONAL_SHARE';
export const GET_GAME_PROFIT_RECORD = 'GET_GAME_PROFIT_RECORD';
export const PLATFORM_STOP_LOADING = 'PLATFORM_STOP_LOADING';
export const TOKEN_STATUS = 'TOKEN_STATUS';


//Gashapon
export const GAMBILING_PROCESS = 'GAMBILING_PROCESS';

//User Operation
export const USER_OPERATION_LOADING = 'USER_OPERATION_LOADING'; //載入
export const GET_PLAYER_RANDOM_GAME_RECORD = 'GET_PLAYER_RANDOM_GAME_RECORD'; //取得亂數遊戲列表
export const PLAYER_CONFIRM_COMMIT = 'PLAYER_CONFIRM_COMMIT'; //玩家 確認要玩
export const PLAYER_CONFIRM_HUNT_COMMIT = 'PLAYER_CONFIRM_HUNT_COMMIT'; //玩家 確認要玩 Hunt
export const SHOW_GAME_TYPE = 'SHOW_GAME_TYPE'; //選擇遊戲類型
export const IS_GET_USER_ADDRESS = 'IS_GET_USER_ADDRESS'; //使用者存在
export const SET_USER_ADDRESS = 'SET_USER_ADDRESS'; //更新address
export const SET_IS_METAMASK_DOWNLOAD = 'SET_IS_METAMASK_DOWNLOAD'; //更新address
export const GET_PROFIT_RECORD_LIST = 'GET_PROFIT_RECORD_LIST'; //取分紅列表
export const SET_PLAYER_WATING_START_AUTOBET = 'SET_PLAYER_WATING_START_AUTOBET'; //等待開始
export const SET_PLAYER_WATING_STOP_AUTOBET = 'SET_PLAYER_WATING_STOP_AUTOBET'; //等待結束
export const SET_IS_SHOW_ANIMATION = 'SET_IS_SHOW_ANIMATION'; //是否有動畫顯示
export const USER_SET_LOW_HIGH = 'USER_SET_LOW_HIGH'; //玩家設定上下限
export const UPDATE_USEROPERATION_STATUS = 'UPDATE_USEROPERATION_STATUS'; //設定使用者狀態
export const UPDATE_PLAYER_CLICK_START = 'UPDATE_PLAYER_CLICK_START'; //玩家按下開始按鈕
export const UPDATE_PLAYER_CLICK_AUTO_START = 'UPDATE_PLAYER_CLICK_AUTO_START'; //玩家按下自動開始按鈕
export const UPDATE_LASTACCOUNT = 'UPDATE_LASTACCOUNT'; //更新使用中的Address
export const UPDATE_MACHINE_INDEX = 'UPDATE_MACHINE_INDEX'; //更新機台index
export const SET_SHOW_SOURCE_STATUS = 'SET_SHOW_SOURCE_STATUS'; //
export const SET_SHOW_SHOT_CHANGE_STATUS = 'SET_SHOW_SHOT_CHANGE_STATUS'; //

//error
export const UPDATE_FRAME_SPILITE_ARRAY = 'UPDATE_FRAME_SPILITE_ARRAY'; //表單要呈現的錯誤資料
export const UPDATE_SHOT_CHANGE_ERROR_DATA = 'UPDATE_SHOT_CHANGE_ERROR_DATA'; // 


//auto
export const AUTO_SWITCH = 'AUTO_SWITCH';
export const AUTO_LOADING = 'AUTO_LOADING';
export const AUTO_STOP_LOADING = 'AUTO_STOP_LOADING';
export const AUTO_GET_BET_INFO = 'AUTO_GET_BET_INFO';
export const AUTO_GET_PLAYER_INFO = 'AUTO_GET_PLAYER_INFO';
export const AUTO_GET_SUB_WALLET = 'AUTO_GET_SUB_WALLET';
export const AUTO_SET_USER_WANT_STATUS = 'AUTO_SET_USER_WANT_STATUS';
export const LAST_GET_AUTOBET_INFO_TS = 'LAST_GET_AUTOBET_INFO_TS';
export const LAST_GET_AUTOBET_INFO_STATUS = 'LAST_GET_AUTOBET_INFO_STATUS';
export const SET_AUTOBET_STATUS = 'SET_AUTOBET_STATUS';
export const CHECK_USER_PROCESS_AMOUNT = 'CHECK_USER_PROCESS_AMOUNT';


//videoPlayer

//克制取代文字
export const SET_MULTIPLE_SHOW = 'SET_MULTIPLE_SHOW';
export const SET_POSITION_ALIGN_SHOW = 'SET_POSITION_ALIGN_SHOW';
export const SET_FRAM_SPLIT_ERROR = 'SET_FRAM_SPLIT_ERROR';
export const SET_MUTLTIPLE_FIND_REPLACE_SHOW = 'SET_MUTLTIPLE_FIND_REPLACE_SHOW';


//視窗動作
export const SET_VIDEO_VIEWWIDTH = 'SET_VIDEO_VIEWWIDTH';
export const SET_SUBTITLES_LEFT = 'SET_SUBTITLES_LEFT';

//客製搜尋
export const SET_MUTILE_FIND_DATA = 'SET_MUTILE_FIND_DATA';
export const SET_CREATE_MUTILE = 'SET_CREATE_MUTILE'; 

//Position 相關
export const SET_SHOW_FIND_POSITION = 'SET_SHOW_FIND_POSITION'; //顯示列表
export const SET_SHOW_FIND_POSITION_DATA = 'SET_SHOW_FIND_POSITION_DATA'; //儲存列表

//Frame 相關
export const UPDATE_FRAME_SPLIT_DATA = 'UPDATE_FRAME_SPLIT_DATA'; //更新資料
export const UPDATE_FRAME_GAP_DATA = 'UPDATE_FRAME_GAP_DATA'; //更新資料 
export const SET_SHOW_FIND_FRAME = 'SET_SHOW_FIND_FRAME'; //顯示列表
export const SET_FRAME_SPLIT_VALUE = 'SET_FRAME_SPLIT_VALUE'; //設定要檢查的Frame split value


//影片
export const UPDATE_VIDEO_CURRENT_TIME = 'UPDATE_VIDEO_CURRENT_TIME'; //使用者影片秒數
export const SET_WAVEFORM_ACTIVE = 'SET_WAVEFORM_ACTIVE'; //大環境的拖拉
export const SET_VIDEO_DURATION = 'SET_VIDEO_DURATION'; //總時間
export const UPDATE_WAVE_VIDEO_CURRENT_TIME = 'UPDATE_WAVE_VIDEO_CURRENT_TIME'; //拖拉


//Frame
export const SET_CURRENT_FRAME = 'SET_CURRENT_FRAME'; //使用者的操作 控制 三組物件
export const SET_CURRENT_DATA_INDEX = 'SET_CURRENT_DATA_INDEX'; //使用者的操作 控制 三組物件

//TimeCode shift
export const SET_FIRST_TIMECODE_INDEX = 'SET_FIRST_TIMECODE_INDEX';
export const SET_LAST_TIMECODE_INDEX = 'SET_LAST_TIMECODE_INDEX';
export const SET_ORG_TIME_STRING = 'SET_ORG_TIME_STRING';
export const SET_NEW_TIME_STRING = 'SET_NEW_TIME_STRING';

//拖拉
export const SET_DRAG_DATA = 'SET_DRAG_DATA';



// WEBPACK FOOTER //
// ./src/actions/types.js